import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import CustomRadioButton from "../../GenericComponents/CustomRadioButton";
import { css } from "aphrodite";
import styles from "../style";
import CustomModal from "../../GenericComponents/CustomModal";

const CallForHelpSettings = (props) => {
  const {
    setCallForHelpSettingsData,
    callForHelpSettings,
    patientDetail,
    closeSettings,
    updateCallForHelpSettings,
  } = props;
  const [enableCallForHelp, setEnableCallForHelp] = useState(false);
  const [updateSettings, setUpdateSettings] = useState(false);
  const [enableUpdateFlag, setEnableUpdateFlag] = useState(false);
  const isSettingsInitialized = useRef(false);
  const initialEnableCallForHelp = useRef(false);

  useEffect(() => {
    const currentValue = callForHelpSettings?.enableCallForHelp;
    if (!isSettingsInitialized.current && typeof currentValue === "boolean") {
      initialEnableCallForHelp.current = currentValue;
      isSettingsInitialized.current = true;
      setEnableUpdateFlag(false);
    }
  }, [callForHelpSettings?.enableCallForHelp]);

  const handleChanges = (fieldName, value) => {
    const nextValue = value.target.checked;
    const updatedSettings = {
      ...(callForHelpSettings || {}),
      [fieldName]: nextValue,
    };
    setEnableCallForHelp(nextValue);
    setEnableUpdateFlag(nextValue !== initialEnableCallForHelp.current);
    setCallForHelpSettingsData(updatedSettings);
  };

  const handleSettingChanges = (fieldName, value) => {
    const updatedSettings = {
      ...(callForHelpSettings || {}),
      [fieldName]: value,
    };
    setEnableCallForHelp(false);
    setEnableUpdateFlag(value !== initialEnableCallForHelp.current);
    setCallForHelpSettingsData(updatedSettings);
  };

  const saveData = () => {
    setUpdateSettings(true);
  };

  const handleUpdate = (fieldName, value) => {
    setUpdateSettings(false);
    if (value && updateCallForHelpSettings) {
      initialEnableCallForHelp.current = Boolean(
        callForHelpSettings?.enableCallForHelp,
      );
      setEnableUpdateFlag(false);
      updateCallForHelpSettings(callForHelpSettings);
    }
  };

  return (
    <container>
      <CustomModal
        header={"Alert"}
        name={"enableCallForHelp"}
        size={"sm"}
        title={"Are you sure to enable the Call for Help On Watch?"}
        show={enableCallForHelp}
        action={handleSettingChanges}
      />
      <CustomModal
        header={"Confirm"}
        name={"updateSettings"}
        size={"sm"}
        title={"Are you sure you want to save the details ?"}
        show={updateSettings}
        action={handleUpdate}
      />
      <div
        style={{
          padding: "2em",
        }}
      >
        <div className={css(styles.header)}>Call for Help Settings</div>
        {Object.keys(callForHelpSettings)?.length > 0 ? (
          <>
            <Form>
              <Form.Group className={css(styles.formGroupStyles)}>
                <Form.Label className={css(styles.settingLabels)}>
                  Enable Call for Help
                </Form.Label>
                <CustomRadioButton
                  name={"enableCallForHelp"}
                  type={"switch"}
                  inline={true}
                  label={""}
                  checked={Boolean(callForHelpSettings?.enableCallForHelp)}
                  action={handleChanges}
                />
              </Form.Group>
            </Form>
            <div style={{ marginTop: "2em", textAlign: "center" }}>
              <Button
                variant="primary"
                type="button"
                className={css(styles.updateButtonStyles)}
                style={{ marginRight: "10px" }}
                disabled={!enableUpdateFlag}
                onClick={saveData}
              >
                Update
              </Button>
              <Button
                variant="secondary"
                type="button"
                className={css(styles.updateButtonStyles)}
                onClick={() => closeSettings()}
              >
                Close
              </Button>
            </div>
          </>
        ) : (
          <div style={{ fontSize: "16px", textTransform: "capitalize", color: "red" }}>
            <label>Not included in your current subscription plan</label>
          </div>
        )}
      </div>
    </container>
  );
};

export default CallForHelpSettings;
